import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

// 代理实例
const proxyAxios: AxiosInstance = axios.create({ baseURL: '/api' });

// 直接请求实例
const directAxios: AxiosInstance = axios.create();

// 请求拦截器（安全类型写法）
proxyAxios.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        // 添加或覆盖 headers
        config.headers.set('Content-Type', 'application/json');

        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = token;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 响应拦截器
proxyAxios.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error('request fail:', error);
        return Promise.reject(error);
    }
);

export { proxyAxios, directAxios };